import styled from 'styled-components';
import {
  mediaQueries,
  typography,
  size,
  colors,
  StarReviews,
  Button as RawButton,
} from '@everlywell/leaves';

import { IconAndText as IconAndTextBase } from '../../IconAndText';

export const HeroWrapper = styled.div`
  padding-bottom: ${size.xl1}px;
  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: 0;
  }
`;

export const StickyOrderBarContainer = styled.div`
  background-color: ${colors.white};
  padding: ${size.md}px ${size.lg}px;
  position: fixed;
  top: 56px;
  z-index: 1;
  width: 100%;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
`;

export const StickyContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const StickyProductName = styled.p`
  ${typography.bodyTextXSmall};
  ${mediaQueries.forTabletHorizontalUp} {
    ${typography.displayText};
  }
`;

export const StickyOrderBtn = styled(RawButton)``;

export const Section = styled.section`
  background-image: linear-gradient(${colors.green1}, ${colors.white});
  position: relative;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: ${size.xl4}px;
  }

  ${mediaQueries.forDesktopUp} {
    padding-top: ${size.xl2}px;
    padding-bottom: ${size.xl1}px;
    margin-bottom: 0;
  }
`;

export const Callout = styled.div`
  ${typography.bodyTextXSmall}
  background-color: ${colors.green2};
  text-align: center;
  padding: ${size.xs1}px ${size.xl1}px;
  margin-bottom: -${size.xl1}px;
  color: ${colors.gray5};

  ${mediaQueries.forTabletHorizontalUp} {
    color: ${colors.gray5};
    padding: ${size.sm}px ${size.xl1}px;
    margin-bottom: 0;
  }

  b {
    font-weight: ${typography.weight.heavy};
  }
`;

export const BottomCallout = styled(Callout)`
  padding: inherit 0;
  margin-top: ${size.md}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaQueries.forTabletHorizontalUp} {
    justify-content: center;
    margin-top: ${size.xl2}px;
  }
`;

const BottomCalloutImg = styled.img`
  width: 66px;
  height: 26px;
  margin: 0 ${size.md}px;
`;

export const BottomCalloutImgL = styled(BottomCalloutImg)`
  margin-left: -24px;
`;

export const BottomCalloutImgR = styled(BottomCalloutImg)`
  margin-right: -24px;
`;

export const DescriptionCallout = styled.div`
  margin-top: ${size.xs1}px;
  ${typography.bodyTextSmall};
  a {
    ${typography.buttonTextSmall};
    background: none;
    border: none;
    color: ${colors.green5};
    cursor: pointer;
    text-decoration: none;
  }
`;

export const SliderContainer = styled.div`
  position: relative;
  margin-bottom: ${size.lg}px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoSection = styled.div``;

export const NameAndPrice = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.forTabletVerticalUp} {
    flex-direction: row;
    justify-content: space-between;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    align-items: center;
  }

  ${mediaQueries.forDesktopUp} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ProductDescriptionHeaderMobile = styled.h1`
  ${typography.h2Text};
  text-align: center;
  margin-top: ${size.md}px;
  font-weight: 400;
  /* Homepage specs shows h1 text being mobile until tablet horizontal - overriding here until we have confirmation that is correct for the styleguide, because we have those going from mobile -> desktop styles at tabletVertical there */
  ${mediaQueries.forTabletVerticalUp} {
    font-size: 2.281rem;
    line-height: 2.75rem;
    letter-spacing: -0.6px;

    ${mediaQueries.forTabletHorizontalUp} {
      ${typography.h2Text}
    }
  }

  ${mediaQueries.forDesktopUp} {
    display: none;
  }
`;

export const ProductDescriptionHeader = styled.h1`
  ${typography.h2Text};
  font-weight: ${typography.weight.book};
  display: none;
  /* Homepage specs shows h1 text being mobile until tablet horizontal - overriding here until we have confirmation that is correct for the styleguide, because we have those going from mobile -> desktop styles at tabletVertical there */
  ${mediaQueries.forTabletVerticalUp} {
    font-size: 2.281rem;
    line-height: 2.75rem;
    letter-spacing: -0.6px;

    ${mediaQueries.forTabletHorizontalUp} {
      ${typography.h2Text};
    }
  }

  ${mediaQueries.forDesktopUp} {
    text-align: left;
    display: block;
  }
`;

export const Stars = styled(StarReviews)`
  margin-top: ${size.xs1}px;
  /* TODO: the StarReviews component was updated to stack by default - not sure why - overriding it here */
  flex-direction: row;
  align-items: center;
  margin-bottom: ${size.xs1}px;

  ${mediaQueries.forDesktopUp} {
    margin-top: ${size.md}px;
  }
`;

export const ProductPrice = styled.h3`
  ${typography.displayText};
  font-weight: ${typography.weight.light};
  color: #2d2d2d;

  ${mediaQueries.forTabletVerticalUp} {
    font-size: 22.8px !important;
  }
`;

export const SubscribeSavings = styled.div`
  display: flex;
  margin-left: ${size.xs2}px;
  align-items: center;
`;

export const SubscribePrice = styled.p`
  ${typography.displayText}
  text-transform: uppercase;
  font-weight: ${typography.weight.book};
  color: ${colors.red3};
  margin-left: ${size.xs2}px;
`;

export const SavingsText = styled.p`
  ${typography.captionText};
  margin-left: 6px;
  line-height: ${size.md}px;
  letter-spacing: 0.3px;
  color: ${colors.red3};
  font-weight: ${typography.weight.xbold};
  min-width: ${size.xl8}px;
  margin-top: ${size.xs2}px;
  text-transform: uppercase;
  ${mediaQueries.forTabletVerticalUp} {
    margin-top: 0;
  }
`;

export const PriceAmount = styled.div`
  display: flex;
  align-items: baseline;
`;

export const PriceSection = styled.div.attrs(props => ({
  showDiscount: props.showDiscount,
}))`
  display: flex;
  align-items: center;
  min-height: ${size.xl1}px;
  margin-top: ${size.sm1}px;
  justify-content: flex-start;

  ${mediaQueries.forTabletVerticalUp} {
    min-height: ${size.xl4}px;
    margin-top: 0;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 0px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    justify-content: center;
  }

  ${mediaQueries.forDesktopUp} {
    min-height: ${size.xl3}px;
    display: flex;
    align-items: baseline;
    margin-left: 0;
    flex-direction: row;
    margin-top: ${size.lg}px;
    justify-content: flex-start;
  }
  ${({ showDiscount }) =>
    showDiscount &&
    `
      ${ProductPrice} {
        padding-top: ${size.xs2};
        ${typography.bodyText};
        font-weight: ${typography.weight.book};
        line-height: 28px;
        text-decoration: line-through;
        text-decoration-thickness: 2px;

        ${mediaQueries.forTabletVerticalUp} {
          ${typography.displayText};
        }

        ${mediaQueries.forDesktopUp} {
          padding-top: 0;
        }
      }
    `}
`;

export const PurchaseSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${size.xs2}px;

  ${mediaQueries.forTabletVerticalUp} {
    margin-top: ${size.xl1}px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    flex: 1 1 50%;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }

  ${mediaQueries.forDesktopUp} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const ProductName = styled.h2`
  ${typography.subtitle};

  ${mediaQueries.forDesktopUp} {
    margin-top: ${size.md}px;
  }
`;

export const ProductDescription = styled.p`
  ${typography.bodyText};
  margin-top: ${size.xs2}px;
`;

export const CollectionMethod = styled(IconAndTextBase)`
  margin-bottom: ${size.lg}px;
  margin-right: ${size.xl2}px;

  ${mediaQueries.forTabletVerticalUp} {
    margin-right: ${size.xl2}px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  ${mediaQueries.forDesktopUp} {
    margin-bottom: 0;
  }
`;

export const CollectionMethods = styled.div`
  margin-top: ${size.sm}px;
  display: flex;
  flex-wrap: wrap;

  ${mediaQueries.forTabletVerticalUp} {
    margin-top: 0;
    padding-top: ${size.md}px;
    flex: 1 1 100%;
    display: flex;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl2}px;
    margin-left: 0;
    padding-top: 0;
  }

  ${mediaQueries.forDesktopUp} {
    margin-top: ${size.lg}px;
  }
`;

export const MeasuresWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: ${size.sm}px;

  ${mediaQueries.forTabletVerticalUp} {
    padding-top: ${size.md}px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: ${size.xl2}px;
  }

  ${mediaQueries.forDesktopUp} {
    padding-top: ${size.lg}px;
  }
`;

export const MeasuresText = styled(IconAndTextBase)`
  align-items: center;

  img {
    margin-top: ${size.xs1}px;
  }
`;

export const ConsultWrapper = styled.div`
  margin-top: ${size.sm}px;
  display: flex;
  flex-wrap: wrap;

  ${mediaQueries.forTabletVerticalUp} {
    margin-top: 0;
    padding-top: ${size.md}px;
    flex: 1 1 100%;
    display: flex;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl2}px;
    margin-left: 0;
    padding-top: 0;
  }

  ${mediaQueries.forDesktopUp} {
    margin-top: ${size.lg}px;
  }
`;

export const ConsultText = styled(IconAndTextBase)`
  align-items: center;

  img {
    margin-top: ${size.xs1}px;
  }
`;

export const ModalButton = styled.button.attrs(props => ({
  role: props.role,
  onClick: props.onClick,
}))`
  ${typography.buttonTextSmall};
  background: none;
  border: none;
  color: ${colors.green5};
  cursor: pointer;
`;

export const DescriptionContent = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.forTabletVerticalUp} {
    max-width: 75%;
  }

  ${mediaQueries.forDesktopUp} {
    max-width: 100%;
  }
`;
